module.exports = __webpack_public_path__ + "static/media/1_A1_03.8851058a.png";